var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FirebaseUser',{scopedSlots:_vm._u([{key:"user",fn:function({ user }){return [_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{attrs:{"user":user}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }